/*
 * Custom B2B (11.09.2026): Haendlerbereich / Mediathek
 * Gehoert zu sections/b2b-mediathek.liquid und assets/b2b-mediathek.css
 * - ZIP-Download der Freisteller (JSZip von cdnjs, wird erst beim Klick geladen)
 * - Filter fuer Imagebilder (Produkt / Motiv / Format), Deep-Link ?produkt=handle
 * - "Neu hinzugefuegt" aus den neuesten Imagebildern
 */
(function () {
  var JSZIP_URL = 'https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';

  function absoluteUrl(url) {
    return url.indexOf('//') === 0 ? window.location.protocol + url : url;
  }

  /* Bilder als JPG/PNG anfordern (nicht WebP/AVIF), damit Haendler sie ueberall verwenden koennen */
  function fetchImage(url) {
    return fetch(absoluteUrl(url), { headers: { Accept: 'image/jpeg,image/png;q=0.9,*/*;q=0.1' } }).then(function (response) {
      if (!response.ok) throw new Error('Bild konnte nicht geladen werden (' + response.status + ')');
      return response.blob();
    });
  }

  function extensionFor(blob) {
    if (blob.type === 'image/png') return 'png';
    if (blob.type === 'image/webp') return 'webp';
    if (blob.type === 'image/avif') return 'avif';
    return 'jpg';
  }

  function saveBlob(blob, filename) {
    var link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    setTimeout(function () {
      URL.revokeObjectURL(link.href);
      link.remove();
    }, 4000);
  }

  var jszipPromise = null;
  function loadJSZip() {
    if (window.JSZip) return Promise.resolve();
    if (!jszipPromise) {
      jszipPromise = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = JSZIP_URL;
        script.onload = resolve;
        script.onerror = function () {
          jszipPromise = null;
          reject(new Error('ZIP-Funktion konnte nicht geladen werden.'));
        };
        document.head.appendChild(script);
      });
    }
    return jszipPromise;
  }

  function tileTitle(tile) {
    var img = tile.querySelector('img');
    return tile.dataset.title || (img && img.alt) || '';
  }

  var MOTIF_ORDER = ['Model', 'Stillleben', 'Detail', 'Social-Post', 'Video'];
  function motifRank(value) {
    var index = MOTIF_ORDER.indexOf(value);
    return index === -1 ? MOTIF_ORDER.length : index;
  }

  function formatRatio(value) {
    var parts = String(value).split(':').map(Number);
    return parts[0] && parts[1] ? parts[1] / parts[0] : 99;
  }

  if (window.customElements.get('b2b-mediathek')) return;

  class B2BMediathek extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-product-card]'));
      this.gallery = this.querySelector('[data-gallery]');
      this.tiles = this.gallery ? Array.prototype.slice.call(this.gallery.querySelectorAll('[data-tile]')) : [];
      this.state = { product: [], motif: [], format: [] };

      this.addEventListener('click', this.onClick.bind(this));
      this.setupFilters();
      this.setupNew();
    }

    /* ------------------------------------------------------------------------------------------------------------- */
    onClick(event) {
      /* Sprungmarken selbst scrollen (das Theme faengt #-Links ab) */
      var anchor = event.target.closest('a[href^="#b2b-mt-"]');
      if (anchor && !anchor.hasAttribute('data-show-product')) {
        var target = this.querySelector(anchor.getAttribute('href'));
        if (target) {
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (window.history.replaceState) window.history.replaceState(null, '', anchor.getAttribute('href'));
        }
        return;
      }

      var zipButton = event.target.closest('[data-zip]');
      if (zipButton) return this.downloadZip(zipButton);

      var showProduct = event.target.closest('[data-show-product]');
      if (showProduct) {
        event.preventDefault();
        this.state = { product: [showProduct.dataset.showProduct], motif: [], format: [] };
        this.applyFilters();
        this.querySelector('#b2b-mt-imagebilder').scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      var filter = event.target.closest('[data-filter-value]');
      if (filter) {
        var list = this.state[filter.dataset.group];
        var index = list.indexOf(filter.dataset.filterValue);
        if (index === -1) list.push(filter.dataset.filterValue);
        else list.splice(index, 1);
        this.applyFilters();
        return;
      }

      if (event.target.closest('[data-reset]')) {
        this.state = { product: [], motif: [], format: [] };
        this.applyFilters();
      }
    }

    /* ZIP --------------------------------------------------------------------------------------------------------- */
    setStatus(card, text, type) {
      var status = card.querySelector('[data-status]');
      if (!status) return;
      status.textContent = text;
      status.className = 'b2b-mt__status text-sm' + (type ? ' is-' + type : '');
    }

    async downloadZip(button) {
      var card = button.closest('[data-product-card]');
      if (!card || card._busy) return;

      var files = [];
      try { files = JSON.parse(card.querySelector('[data-files]').textContent); } catch (e) { files = []; }
      if (!files.length) return;

      var size = button.dataset.size === 'original' ? 'original' : 'web';
      var buttons = card.querySelectorAll('[data-zip]');
      card._busy = true;
      buttons.forEach(function (b) { b.disabled = true; });

      try {
        this.setStatus(card, 'ZIP wird vorbereitet …');
        await loadJSZip();

        var zip = new window.JSZip();
        var queue = files.slice();
        var usedNames = {};
        var done = 0;
        var self = this;

        async function worker() {
          while (queue.length) {
            var file = queue.shift();
            var blob = await fetchImage(file[size]);
            var name = file.name;
            usedNames[name] = (usedNames[name] || 0) + 1;
            if (usedNames[name] > 1) name += '-' + usedNames[name];
            zip.file(name + '.' + extensionFor(blob), blob);
            done += 1;
            self.setStatus(card, 'Bilder werden geladen … ' + done + ' / ' + files.length);
          }
        }

        await Promise.all([worker(), worker(), worker(), worker()]);

        this.setStatus(card, 'ZIP wird erstellt …');
        var content = await zip.generateAsync({ type: 'blob' });
        saveBlob(content, (card.dataset.productHandle || 'freisteller') + '-freisteller-' + (size === 'original' ? 'original' : '2000px') + '.zip');
        this.setStatus(card, '✓ ' + files.length + ' Bilder heruntergeladen.', 'success');
      } catch (error) {
        this.setStatus(card, error.message || 'Download fehlgeschlagen.', 'error');
      } finally {
        card._busy = false;
        buttons.forEach(function (b) { b.disabled = false; });
      }
    }

    /* Filter ------------------------------------------------------------------------------------------------------ */
    tileMatches(tile, group, value) {
      if (group === 'product') return (' ' + tile.dataset.products + ' ').indexOf(' ' + value + ' ') !== -1;
      return tile.dataset[group] === value;
    }

    setupFilters() {
      var filters = this.querySelector('[data-filters]');
      var empty = this.querySelector('[data-empty]');
      var self = this;

      if (!this.tiles.length) {
        if (empty) {
          empty.hidden = false;
          empty.querySelector('[data-empty-text]').textContent = 'Imagebilder folgen in Kürze.';
          empty.querySelector('[data-reset]').hidden = true;
        }
        return;
      }

      /* Produktnamen: Reihenfolge wie die Freisteller-Kacheln, danach weitere Produkte aus den Bildern */
      var names = {};
      var order = [];
      this.cards.forEach(function (card) {
        names[card.dataset.productHandle] = card.dataset.productTitle;
        order.push(card.dataset.productHandle);
      });
      this.tiles.forEach(function (tile) {
        var handles = tile.dataset.products.split(/\s+/).filter(Boolean);
        var titles = (tile.dataset.productNames || '').split('|');
        handles.forEach(function (handle, i) {
          if (!names[handle]) { names[handle] = titles[i] || handle; order.push(handle); }
        });
      });

      /* Galerie sortieren: Produkt (Reihenfolge der Kacheln), dann Titel */
      var rank = function (tile) {
        var first = tile.dataset.products.split(/\s+/)[0];
        var index = order.indexOf(first);
        return index === -1 ? order.length : index;
      };
      this.tiles.sort(function (a, b) {
        return rank(a) - rank(b) || tileTitle(a).localeCompare(tileTitle(b), 'de', { numeric: true });
      });
      this.tiles.forEach(function (tile) { self.gallery.appendChild(tile); });

      var values = {
        product: order.filter(function (handle) {
          return self.tiles.some(function (tile) { return self.tileMatches(tile, 'product', handle); });
        }),
        motif: unique(this.tiles.map(function (tile) { return tile.dataset.motif; })).sort(function (a, b) { return motifRank(a) - motifRank(b); }),
        format: unique(this.tiles.map(function (tile) { return tile.dataset.format; })).sort(function (a, b) { return formatRatio(a) - formatRatio(b); })
      };

      Object.keys(values).forEach(function (group) {
        var row = filters.querySelector('[data-group="' + group + '"]');
        if (values[group].length < 2) { row.hidden = true; return; }
        var wrap = row.querySelector('.b2b-mt__filter-chips');
        values[group].forEach(function (value) {
          var count = self.tiles.filter(function (tile) { return self.tileMatches(tile, group, value); }).length;
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'b2b-mt__filter';
          button.dataset.group = group;
          button.dataset.filterValue = value;
          button.setAttribute('aria-pressed', 'false');
          button.textContent = group === 'product' ? names[value] : value;
          var small = document.createElement('small');
          small.textContent = count;
          button.appendChild(small);
          wrap.appendChild(button);
        });
      });

      /* Links "Imagebilder mit diesem Produkt" nur zeigen, wenn es Bilder gibt */
      this.querySelectorAll('[data-show-product]').forEach(function (link) {
        link.hidden = values.product.indexOf(link.dataset.showProduct) === -1;
      });

      var preset = new URLSearchParams(window.location.search).get('produkt');
      if (preset && values.product.indexOf(preset) !== -1) this.state.product = [preset];

      filters.hidden = false;
      this.applyFilters();

      function unique(list) {
        return list.filter(function (value, i) { return value && list.indexOf(value) === i; });
      }
    }

    applyFilters() {
      var self = this;
      var shown = 0;
      var active = Object.keys(this.state).some(function (group) { return self.state[group].length; });

      this.tiles.forEach(function (tile) {
        var visible = Object.keys(self.state).every(function (group) {
          var list = self.state[group];
          return !list.length || list.some(function (value) { return self.tileMatches(tile, group, value); });
        });
        tile.hidden = !visible;
        if (visible) shown += 1;
      });

      this.querySelectorAll('.b2b-mt__filter').forEach(function (button) {
        button.setAttribute('aria-pressed', self.state[button.dataset.group].indexOf(button.dataset.filterValue) !== -1 ? 'true' : 'false');
      });

      var count = this.querySelector('[data-count]');
      if (count) count.textContent = shown + (shown === 1 ? ' Bild' : ' Bilder');
      this.querySelectorAll('[data-filters] [data-reset]').forEach(function (button) { button.hidden = !active; });

      var empty = this.querySelector('[data-empty]');
      if (empty) empty.hidden = shown > 0;
    }

    /* Neu hinzugefuegt -------------------------------------------------------------------------------------------- */
    setupNew() {
      var limit = parseInt(this.dataset.newCount, 10) || 0;
      var grid = this.querySelector('[data-new-grid]');
      if (!limit || !grid || !this.tiles.length) return;

      var newest = this.tiles
        .filter(function (tile) { return tile.dataset.date; })
        .sort(function (a, b) { return b.dataset.date.localeCompare(a.dataset.date); })
        .slice(0, limit);
      if (!newest.length) return;

      newest.forEach(function (tile) {
        var clone = tile.cloneNode(true);
        clone.removeAttribute('data-tile');
        clone.hidden = false;
        grid.appendChild(clone);
      });

      this.querySelector('#b2b-mt-neu').hidden = false;
      var nav = this.querySelector('[data-new-nav]');
      if (nav) nav.hidden = false;
    }
  }

  window.customElements.define('b2b-mediathek', B2BMediathek);
})();